// extracted by mini-css-extract-plugin
export default {"carouserl_wrap":"HomeCarousel_carouserl_wrap__NXxZy","control_btn":"HomeCarousel_control_btn__4R4wA","next":"HomeCarousel_next__VVOjB","prev":"HomeCarousel_prev__UYo7r"};